// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__7dIj9","copyLeft":"Footer_copyLeft__3HvzI","mainDiv":"Footer_mainDiv__2Tz0n"};